module.exports = __webpack_public_path__ + "img/bio_param.524fb419.svg";